import DescriptionInfo from './DescriptionInfo';
import GeneralInfo from './GeneralInfo';
import ProductBaseForm from './ProductBaseForm';

export { ProductBaseForm, DescriptionInfo, GeneralInfo };
